module.exports = __webpack_public_path__ + "img/79200.14c672a4.jpg";